import React, { Component, useState, useEffect, useRef } from 'react';
import { Link, useParams, Router } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody, Row } from 'reactstrap';
import { API_URL } from '../../../Config/index.js';
import Header from '../header.js';
import Login from './Login.js';
import Faculty from '../Faculty/Faculty.js';

const LoginPage = () => {

       return (
        <div>

        <div className="main-bg">
            <Header hideLoginButton={true} />
                         <Faculty message={"Student/Faculty, Please login here."} />
                <div className='container-fluid'>

           <div className='grid pt-0 pb-0' >
           <div className='col-6 offset-3 mt-5'>
            
                <Login />
           </div>
           </div>
           </div>
           </div>
           </div>
       )
}

export default LoginPage;
